import script from "./PlanTraficCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanTraficCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./PlanTraficCreateForm.vue?vue&type=style&index=0&id=be09aac4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be09aac4"]])

export default __exports__